import { useStore } from 'zustand';

import { StatusStore } from '../services';

export const useSellerCommunicationsStatus = () => {
	const { statuses } = useStore(StatusStore);
	return statuses;
};
